import * as React from 'react';

function SvgValetCircleSolid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={44} height={44} viewBox="0 0 44 44" {...props}>
      <path
        fillRule="evenodd"
        d="M22 0a22 22 0 11-8.54 42.28 9.7 9.7 0 015.16-3.02l.35-.07 9.74-1.87a6.5 6.5 0 003.16-1.59l.22-.2 5.8-5.83a1.37 1.37 0 000-1.94c-.5-.5-1.28-.53-1.82-.1l-.1.1-6.1 6.1H15.79a.4.4 0 01-.4-.33v-.17a.4.4 0 01.11-.19.3.3 0 01.1-.06.36.36 0 01.12-.05h5.85a1.27 1.27 0 00-.21-2.49h-8.29c-3.31.07-5.01 1.92-5.28 3.93a5.4 5.4 0 01-1.46 2.57l-.17.2A22 22 0 0122 0zm7.74 27.58a2.54 2.54 0 00-3.46-.12l-.13.12L23 30.73a1.92 1.92 0 010 2.2l-.09.12h1.36l5.47-5.47zm4.64-1.5c-.46-.47-1.2-.5-1.7-.1l-.1.1-6.97 6.97h3.59l5.18-5.18a1.26 1.26 0 000-1.8zM22.28 5a4.77 4.77 0 00-1.43 9.31l.2.06v2.92l.84 1.17-.83 1.18v.07l.83 1.17-.83 1.18 1.29 3.69 1.24-1.42v-9.98l.2-.06A4.77 4.77 0 0022.29 5zm0 1.58a1.5 1.5 0 110 3.01 1.5 1.5 0 010-3.01z"
      />
    </svg>
  );
}

export default SvgValetCircleSolid;
